query QueueJobsListQuery(
  $queueName: String!
  $types: [String]
  $page: Int
  $rowsPerPage: Int
) {
  queue(name: $queueName) {
    id
    name
    jobs(types: $types, page: $page, rowsPerPage: $rowsPerPage) {
      count
      nodes {
        id
        name
        data
        delay
        steps
        timestamp
        progress
        result
        state
        stacktrace
        attemptsMade
        failedReason
        finishedOn
        processedOn
      }
    }
  }
}
